<template>
	<b-button pill block variant="light" @click="toDashboard()">{{$t('navigate.to.dashboard')}}</b-button>
</template>

<script>
export default {
methods: {
	 toDashboard: function(){
      this.$store.dispatch( 'showDashboard' )
      // this.$store.dispatch('updateDashboardData')
		},
}
}
</script>

<style>

</style>